import { useRef } from 'react'

import { Box, useIntersectViewport } from '@revolut-internal/ui-kit'

import { FCWithChildren } from 'modules/Monitoring/types'

type InfiniteLoaderProps = {
  isPending: boolean
  hasMore?: boolean
  onLoadMore: VoidFunction
}

export const InfiniteLoader: FCWithChildren<InfiniteLoaderProps> = ({
  isPending,
  hasMore = false,
  onLoadMore,
  children,
}) => {
  const ref = useRef(null)

  useIntersectViewport(
    isPending ? undefined : ref,
    isIntersecting => isIntersecting && onLoadMore(),
  )

  if (!hasMore) {
    return null
  }

  return <Box ref={ref}>{children}</Box>
}
